import {
  GetMessageObjectEnumResponse,
  GetMessageObjectInterface,
} from '../components/aws/types';

export const getMessage = (
  options?: GetMessageObjectInterface,
): GetMessageObjectEnumResponse => {
  const messageEnum: GetMessageObjectEnumResponse = Object.freeze({
    REFRESHING: 'Refreshing to show updates. This may take a couple minutes.',
    FAILURE: `Failed to ${options?.failureToDo}. Please try again in a few minutes or contact the Cloud Platform Team for support at portal.developer.principal.com/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/principal/support/#internal-support`,
    SUCCESS: options?.successMessage ?? '',
  });

  return messageEnum;
};
